<template>
<div class="chapter">
<div class="inner_page">
<div class="pgbreak" epub:type="pagebreak" id="page_xi" title="xi">
<h1 class="HT"><span class="small">IN</span> SEARCH <span class="small">OF THE</span> HEBREW PEOPLE</h1>
<div class="pgbreak" epub:type="pagebreak" id="page_xii" title="xii">
</div></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Halftitle2.vue?94cd49de